import { COLORS } from '@disy/lib/colors';

export const DEFAULT_UNIFORM_COLOR = COLORS.COLOR_GRAY_04; // keep synchronized with ClassificationColorAssignmentService#DEFAULT_UNIFORM_COLOR
